import { useQuery } from "@apollo/client";
import { GET_INTERVIEW_SCHEDULING_LOCATION_OPTIONS } from "graphql/queries/interviewSchedulingSettings";

const useInterviewSchedulingLocationOptions = ({ skip = false } = {}) => {
  const { data, loading, error, refetch } = useQuery(GET_INTERVIEW_SCHEDULING_LOCATION_OPTIONS, {
    skip,
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
  });

  return {
    options: loading || error ? [] : data?.interviewSchedulingLocationOptions || [],
    loading,
    error,
    refresh: () => refetch().catch(() => {}),
  };
};

export default useInterviewSchedulingLocationOptions;
